export default __webpack_public_path__ + "static/mixtures-f95be22324b830d44f2f2fcb6b7681e6.png";